import type { AssessmentListItemForUser, HtsSubmissionListItemForUser } from '@/services/api';

// The two kinds of past session the candidate can have — an interview
// Assessment or an HTS submission. Interleaved into one date-sorted list.
export const HistoryItemKind = {
  Assessment: 'assessment',
  Hts: 'hts',
} as const;

export type HistoryItem =
  | { kind: typeof HistoryItemKind.Assessment; key: string; date: string; item: AssessmentListItemForUser }
  | { kind: typeof HistoryItemKind.Hts; key: string; date: string; item: HtsSubmissionListItemForUser };
